import { Box, CircularProgress } from '@mui/material'
import React from 'react'

const ReusableLoader = ({ label = "Loading" }) => {
  return (
    <Box
      sx={{ width: "100%", height: "100%" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <CircularProgress aria-hidden="true" />
    </Box>
  )
}

export default ReusableLoader
